var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedOutlineShirt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "red-outline-shirt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    fill: "#fff",
    stroke: "#f26363",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shirt",
    transform: "translate(6 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M8,4.5h2.295c.125-.125,1.35-1.355,1.355-1.355A.565.565,0,0,1,12,3h6.5a.5.5,0,0,1,.355.145L20.2,4.5H22a2,2,0,0,1,2,2V21a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V6.5A2,2,0,0,1,8,4.5Zm3.88-.175-.78.785,2.1,4.615,1.155-.865ZM12.84,4l2.195,4L17.59,4Zm5.745.3L15.67,8.88l1.17.875L19.38,5.09ZM7,21a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V6.5a1,1,0,0,0-1-1h-1.7L17.44,10.74a.5.5,0,0,1-.74.16L15,9.625,13.3,10.9a.5.5,0,0,1-.755-.195L10.18,5.5H8a1,1,0,0,0-1,1Z",
    transform: "translate(-6 -3)",
    fill: "#f26363"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 8.5)",
    fill: "#f26363"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 12)",
    fill: "#f26363"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 15.5)",
    fill: "#f26363"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedOutlineShirt);
export default __webpack_public_path__ + "static/media/red-outline-shirt.56802e5c3c34b8747fee4e222ba251e4.svg";
export { ForwardRef as ReactComponent };